var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10c-.276 0-.5.224-.5.5v6c0 .66 1 .668 1 0V14h1.5c.665 0 .65-1 0-1H8v-2h2.5c.66.01.66-1 0-1zm13 0c-.276 0-.5.224-.5.5v6c0 .672 1 .653 1 0V14h.5c.832 0 1.468-.206 1.896-.59.43-.383.604-.92.604-1.41 0-.49-.175-1.027-.604-1.41-.428-.384-1.064-.59-1.896-.59zm.5 1h.5c.668 0 1.032.16 1.23.336.195.175.27.39.27.664 0 .273-.075.49-.27.664-.198.176-.562.336-1.23.336H21zm-7.5-1c-.66 0-.66 1 0 1H15v5.5c0 .67 1 .665 1 0V11h1.5c.66.01.662-1 0-1zm2 9c-.13.002-.26.055-.353.146l-3.994 3.995c-.464.446.26 1.17.706.707l3.64-3.642 3.64 3.642c.454.472 1.175-.257.707-.706l-3.994-3.994c-.096-.095-.218-.148-.353-.146zm0 3c.277 0 .5.223.5.5v7c0 .277-.223.5-.5.5s-.5-.223-.5-.5v-7c0-.277.223-.5.5-.5zM1.5 0C.678 0 0 .678 0 1.5v23c0 .822.678 1.5 1.5 1.5h7c.667 0 .66-1 0-1h-7c-.286 0-.5-.214-.5-.5v-23c0-.286.214-.5.5-.5h7c.5 0 .647.007.777.072.13.066.37.282.87.782l3 3c.516.516.865.81 1.248.98.382.17.733.166 1.105.166h13c.286 0 .5.214.5.5v18c0 .286-.214.5-.5.5h-6c-.646 0-.672 1 0 1h6c.822 0 1.5-.678 1.5-1.5v-18c0-.822-.678-1.5-1.5-1.5h-13c-.373 0-.52-.002-.7-.082-.182-.08-.46-.285-.946-.772l-3-3c-.5-.5-.762-.784-1.13-.968C9.353-.007 9 0 8.5 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtp);
export default __webpack_public_path__ + "static/media/ftp.380003dbedf16e3d41abaff41e527a0c.svg";
export { ForwardRef as ReactComponent };